import moment from 'moment'; 

export const initialDemoState = {
    sprints: [
        {
            id: "demo_00",
            name: 'Sprint #00 - Off-Semester Maintenance',
            startDate: moment.utc(moment().subtract(53,'day')),
            endDate: moment.utc(moment().subtract(26,'day')),
            participants: 'Mike, Patrick, Zoe',
            owner: 'Mike',
            projects: [
                {
                    id: { value: 1 },
                    name: { value: 'Professional Development Planning for Upcoming Year' },
                    manager: { value: 'Mike' },
                    description: { value: 'Survey team about prior year PD. Collect external PD opportunities. Brainstorm internal PD topics.' },
                    category: { value: 'Team Management and Professional Development' },
                    categoryLead: { value: 'Mike' },
                    estimatedProjectSize: { value: '5 - Medium' },
                    mustDo: { value: 'Nice-to-Have' },
                    externalDueDate: { value: 'n/a' },
                    deliverables: { value: 'Draft PD plan for sharing with the team' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: 'Yes' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '0%' },
                    statusEndOfWeek2: { value: '50%' },
                    statusEndOfWeek3: { value: '100%' },
                    statusEndOfWeek4: { value: '100%' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 2 },
                    name: { value: 'Refactor Common Data Pulls' },
                    manager: { value: 'Zoe' },
                    description: { value: 'Evaluate most common data pulls from prior year and refactor for performance.' },
                    category: { value: 'Data Pulls' },
                    categoryLead: { value: 'Zoe' },
                    estimatedProjectSize: { value: '13 - Large' },
                    mustDo: { value: 'Nice-to-Have' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'Checklist of most common data pulls, with actions taken or "no action necessary."' },
                    deliverableLink: { value: '' },
                    notes: { value: 'Exclude attendance data pulls, which Patrick will handle separately.' },
                    completionStatus: { value: 'Yes' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '25%' },
                    statusEndOfWeek2: { value: '50%' },
                    statusEndOfWeek3: { value: '75%' },
                    statusEndOfWeek4: { value: '100%' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 3 },
                    name: { value: 'Re-create Attendance Data Pulls in New System' },
                    manager: { value: 'Patrick' },
                    description: { value: 'Re-create high-priority attendance queries in the new attendance system and test with mock data.' },
                    category: { value: 'Attendance' },
                    categoryLead: { value: 'Patrick' },
                    estimatedProjectSize: { value: '21 - Extra Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'At least the 5 most common queries complete and tested in the new system.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: 'No, but mostly did' },
                    notCompletedExplanation: { value: 'Initial query setup took longer than anticipated. Only got through 4 of the top 5.' },
                    statusEndOfWeek1: { value: '25%' },
                    statusEndOfWeek2: { value: '50%' },
                    statusEndOfWeek3: { value: '50%' },
                    statusEndOfWeek4: { value: '75%' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                }
            ]
        },
        {
            id: "demo_0",
            name: 'Sprint #0 - Semester Launch Preparation',
            startDate: moment.utc(moment().subtract(23,'day')),
            endDate: moment.utc(moment().subtract(10,'day')),
            participants: 'Patrick, Sally, Mario',
            owner: 'Mike',
            projects: [
                {
                    id: { value: 4 },
                    name: { value: 'Finish Importing Attendance Queries' },
                    manager: { value: 'Patrick' },
                    description: { value: 'Finish moving 5th attendance query into the new system. Optionally add others if have time.' },
                    category: { value: 'Attendance' },
                    categoryLead: { value: 'Patrick' },
                    estimatedProjectSize: { value: '3 - Small-to-Medium' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'At least the 5 most common queries complete and tested in the new system.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: 'Yes' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '75%' },
                    statusEndOfWeek2: { value: '100%' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 5 },
                    name: { value: 'Create School-wide Schedules for 11 Schools' },
                    manager: { value: 'Sally' },
                    description: { value: 'Generate draft schedules for all 11 schools. Get them approved by school leaders. Produce final versions.' },
                    category: { value: 'Scheduling' },
                    categoryLead: { value: 'Sally' },
                    estimatedProjectSize: { value: '21 - Extra Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '3 days before first day of school' },
                    deliverables: { value: '11 school-wide schedules uploaded into the student information system covering 100% of enrolled students.' },
                    deliverableLink: { value: '' },
                    notes: { value: 'All hands on deck for this!' },
                    completionStatus: { value: 'Yes' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '50%' },
                    statusEndOfWeek2: { value: '100%' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 6 },
                    name: { value: 'Complete SIS Checklist for School Launch' },
                    manager: { value: 'Mario' },
                    description: { value: "Revisit last year's school launch checklist for the SIS. Figure out edits/additions. Run through before students arrive." },
                    category: { value: 'Student Information System' },
                    categoryLead: { value: 'Mario' },
                    estimatedProjectSize: { value: '8 - Medium-to-Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '1 day before first day of school' },
                    deliverables: { value: 'New tab in the team tracker with an updated and completed SIS checklist' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: 'Yes' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '25%' },
                    statusEndOfWeek2: { value: '75%' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                }
            ]
        },
        {
            id: 'demo_1',
            name: 'Sprint #1 - School Launch',
            startDate: moment.utc(moment().subtract(7,'day')),
            endDate: moment.utc(moment().add(6,'day')),
            participants: 'Mike, Bobby, Mario, Patrick, Zoe, Sally',
            owner: 'Mike',
            projects: [
                {
                    id: { value: 7 },
                    name: { value: 'Final School Schedule QA' },
                    manager: { value: 'Sally' },
                    description: { value: 'Develop QA checklist for schedules generated last sprint. Run through checklist at school, grade, classroom, and student levels using SQL.' },
                    category: { value: 'Scheduling' },
                    categoryLead: { value: 'Sally' },
                    estimatedProjectSize: { value: '13 - Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: 'First Day of School' },
                    deliverables: { value: 'Completed QA tracker.' },
                    deliverableLink: { value: '' },
                    notes: { value: 'May not be worth tracking every student in a spreadsheet. Should do programatically in SQL.' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '50%' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 8 },
                    name: { value: 'Generate Schedules for Late-Enrolling Students' },
                    manager: { value: 'Bobby' },
                    description: { value: 'Generate individual schedules for late-enrolling students until enrollment settles down ~2 weeks into the year. Then we can transition the responsibility to Operations Managers.' },
                    category: { value: 'Scheduling' },
                    categoryLead: { value: 'Sally' },
                    estimatedProjectSize: { value: '8 - Medium-to-Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'Individual student tracker + working schedules in SIS.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '25%' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 9 },
                    name: { value: 'Test Attendance Workflow in SIS Staging & Update School-Facing Docs' },
                    manager: { value: 'Patrick' },
                    description: { value: 'Test the new school year attendance workflow in the staging version of the SIS, including updates from the vendor. Then update the school-facing docs for teachers and Operations Managers.' },
                    category: { value: 'Attendance' },
                    categoryLead: { value: 'Patrick' },
                    estimatedProjectSize: { value: '5 - Medium' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: 'First Day of School' },
                    deliverables: { value: 'Updated attendance training and reference docs.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '0%' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 10 },
                    name: { value: 'QA New School Year Courses Flowing Through to Transcripts' },
                    manager: { value: 'Bobby' },
                    description: { value: 'Compare list of school year courses on schedules to those appearing on transcript and ensure 1-to-1 match for each school site.' },
                    category: { value: 'Grades & Transcripts' },
                    categoryLead: { value: 'Bobby' },
                    estimatedProjectSize: { value: '3 - Small-to-Medium' },
                    mustDo: { value: 'Nice-to-Have' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'Completed verification tracker.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '25%' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 11 },
                    name: { value: 'Prepare School Launch Data Pulls for Leadership Team' },
                    manager: { value: 'Zoe' },
                    description: { value: 'Vet list of data pulls Mike collected from the LT and make sure they are feasible. Prepare at least the Priority 1 queries.' },
                    category: { value: 'Data Pulls' },
                    categoryLead: { value: 'Zoe' },
                    estimatedProjectSize: { value: '13 - Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: "Revisions to Mike's data pull doc and completed queries in SIS." },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '50%' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 12 },
                    name: { value: 'Update Student Information System Training Materials for New Operations Managers' },
                    manager: { value: 'Mario' },
                    description: { value: 'Process all off-semester SIS updates from the vendor and consider any workflow changes we should make. Update the training materials for the OM school year kickoff session.' },
                    category: { value: 'Student Information System' },
                    categoryLead: { value: 'Mario' },
                    estimatedProjectSize: { value: '3 - Small-to-Medium' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: 'OM kickoff session 2 days before school start' },
                    deliverables: { value: 'Updated Google Slides for training session' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: 'Yes' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '100%' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
            ]
        },
        {
            id: 'demo_2',
            name: 'Sprint #2 - Post-Launch Cleanup',
            startDate: moment.utc(moment().add(9,'day')),
            endDate: moment.utc(moment().add(29,'day')),
            participants: 'Mike, Bobby, Mario, Patrick, Zoe, Sally',
            owner: 'Mike',
            projects: [
                {
                    id: { value: 13 },
                    name: { value: 'Generate School Launch Data Reports for Leadership Team' },
                    manager: { value: 'Zoe' },
                    description: { value: 'Complete any queries remaining from last sprint. Pull interim results and have team QA.' },
                    category: { value: 'Data Pulls' },
                    categoryLead: { value: 'Zoe' },
                    estimatedProjectSize: { value: '13 - Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: "Final, QAed Google Slides and Sheets with all pulls." },
                    deliverableLink: { value: '' },
                    notes: { value: 'Make sure Mike gives the final approval.' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 14 },
                    name: { value: 'Make Sure Schedule Change Requests Reflected on Draft Transcripts' },
                    manager: { value: 'Bobby' },
                    description: { value: 'See if this can be done with a query. If not, manually compare a random selection of students from the schedule change tracker to their updated transcripts. Resolve any discrepancies system-wide.' },
                    category: { value: 'Grades & Transcripts' },
                    categoryLead: { value: 'Bobby' },
                    estimatedProjectSize: { value: '5 - Medium' },
                    mustDo: { value: 'Nice-to-Have' },
                    externalDueDate: { value: '' },
                    deliverables: { value: '100% alignment between courses and transcripts in the SIS' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 15 },
                    name: { value: '[Placeholder for preparing first team PD session]' },
                    manager: { value: 'Mike' },
                    description: { value: 'Topic TBD' },
                    category: { value: 'Team Management and Professional Development' },
                    categoryLead: { value: 'Mike' },
                    estimatedProjectSize: { value: '3 - Small-to-Medium' },
                    mustDo: { value: 'Nice-to-Have' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'PD slides prepared and delivered during our Friday team meeting.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                }
            ]
        },
        {
            id: 'demo_3',
            name: 'Sprint #3 - Maintenance Sprint',
            startDate: moment.utc(moment().add(32,'day')),
            endDate: moment.utc(moment().add(87,'day')),
            participants: 'Mike, Bobby, Mario, Patrick, Zoe, Sally',
            owner: 'Mike',
            projects: [
                {
                    id: { value: 16 },
                    name: { value: 'Build Attendance Tracking Dashboard' },
                    manager: { value: 'Patrick' },
                    description: { value: 'Spec out and build an attendance tracking dashboard. Jesse the school leader has volunteered to thought partner on this.' },
                    category: { value: 'Attendance' },
                    categoryLead: { value: 'Patrick' },
                    estimatedProjectSize: { value: '21 - Extra Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'v1 of an attendance dashboard ready to roll out to schools' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 17 },
                    name: { value: 'Plan and Execute School Scheduling Post-Mortem' },
                    manager: { value: 'Sally' },
                    description: { value: 'Similar to the graduation transcripts post-mortem from last year, run a post-mortem for the scheduling process. If possible, analyze the count of schedule errors this year vs. last.' },
                    category: { value: 'Scheduling' },
                    categoryLead: { value: 'Sally' },
                    estimatedProjectSize: { value: '8 - Medium-to-Large' },
                    mustDo: { value: 'Nice-to-Have' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'Post-mortem meeting with at least 2 school leaders and 2 OMs. Summary doc of learnings that can be shared org-wide.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 18 },
                    name: { value: 'Troubleshoot Teacher Gradebook Issues' },
                    manager: { value: 'Bobby' },
                    description: { value: 'Enough tickets have been filed on gradebook issues that probably requires a deep dive to identify root causes.' },
                    category: { value: 'Grades & Transcripts' },
                    categoryLead: { value: 'Bobby' },
                    estimatedProjectSize: { value: '13 - Large' },
                    mustDo: { value: 'Nice-to-Have' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'All gradebook tickets closed and root causes identified and addressed in the SIS.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                }
            ]
        },
        {
            id: 'demo_4',
            name: 'Sprint #4 - Graduation Setup',
            startDate: moment.utc(moment().add(90,'day')),
            endDate: moment.utc(moment().add(103,'day')),
            participants: 'Mike, Bobby, Mario, Patrick, Zoe, Sally',
            owner: 'Mike',
            projects: [
                {
                    id: { value: 19 },
                    name: { value: 'Generate Students in Danger of Retention Lists' },
                    manager: { value: 'Bobby' },
                    description: { value: 'Based on the mid-semester grades, generate the list of students with below 2.0 GPAs that are in danger of retention.' },
                    category: { value: 'Grades & Transcripts' },
                    categoryLead: { value: 'Bobby' },
                    estimatedProjectSize: { value: '3 - Small-to-Medium' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: "QA'ed list delivered to the Academics Team." },
                    deliverableLink: { value: '' },
                    notes: { value: 'Choose at least one school and confirm with Operations Manager on site that list matches theirs.' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 20 },
                    name: { value: 'Implement GPA Calculation Formula, Including Honors and AP Weightings' },
                    manager: { value: 'Bobby' },
                    description: { value: 'Given the Academics Team tweaks to the GPA formula, make sure the formula in the SIS matches. Manually calculate student GPAs to QA.' },
                    category: { value: 'Grades & Transcripts' },
                    categoryLead: { value: 'Bobby' },
                    estimatedProjectSize: { value: '8 - Medium-to-Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: "Updated and QA'ed formula in the SIS" },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                },
                {
                    id: { value: 21 },
                    name: { value: 'Create End-of-Semester Data Pull Templates for Teachers' },
                    manager: { value: 'Zoe' },
                    description: { value: "Update queries in the SIS from last year's tables and create new templates so teachers can self-serve." },
                    category: { value: 'Data Pulls' },
                    categoryLead: { value: 'Zoe' },
                    estimatedProjectSize: { value: '13 - Large' },
                    mustDo: { value: 'Must Do' },
                    externalDueDate: { value: '' },
                    deliverables: { value: 'Finalized set of data pull templates in the SIS.' },
                    deliverableLink: { value: '' },
                    notes: { value: '' },
                    completionStatus: { value: '' },
                    notCompletedExplanation: { value: '' },
                    statusEndOfWeek1: { value: '' },
                    statusEndOfWeek2: { value: '' },
                    statusEndOfWeek3: { value: '' },
                    statusEndOfWeek4: { value: '' },
                    statusEndOfWeek5: { value: '' },
                    statusEndOfWeek6: { value: '' },
                    statusEndOfWeek7: { value: '' },
                    statusEndOfWeek8: { value: '' },
                }
            ]
        },

    ], // End of sprints
    queue: [
        {
            id: { value: 22 },
            name: { value: 'Onboard Operations Managers in "Deliberate Sprints"' },
            manager: { value: 'Mike' },
            description: { value: 'Based on experience with Data Team, onboard OMs into the "Deliberate Sprints" tool at the mid-semester OM retreat' },
            category: { value: 'Team Management and Professional Development' },
            categoryLead: { value: 'Mike' },
            estimatedProjectSize: { value: '21 - Extra Large' },
            mustDo: { value: 'Nice-to-Have' },
            externalDueDate: { value: '' },
            deliverables: { value: 'Training docs for fall retreat. At least one team of OMs using the tool regularly by the end of the semester.' },
            deliverableLink: { value: '' },
            notes: { value: '' },
            completionStatus: { value: '' },
            notCompletedExplanation: { value: '' },
            statusEndOfWeek1: { value: '' },
            statusEndOfWeek2: { value: '' },
            statusEndOfWeek3: { value: '' },
            statusEndOfWeek4: { value: '' },
            statusEndOfWeek5: { value: '' },
            statusEndOfWeek6: { value: '' },
            statusEndOfWeek7: { value: '' },
            statusEndOfWeek8: { value: '' },
        },
        {
            id: { value: 23 },
            name: { value: 'Investigate Alternative Student Information Systems' },
            manager: { value: 'Mario' },
            description: { value: 'The lack of support in our SIS for schools outside is quite painful, so investigate SISs that offer broader national support. Choose a top 2-3 alternate vendors for further investigation.' },
            category: { value: 'Student Information System' },
            categoryLead: { value: 'Mario' },
            estimatedProjectSize: { value: '13 - Large' },
            mustDo: { value: 'Nice-to-Have' },
            externalDueDate: { value: '' },
            deliverables: { value: 'List of 2-3 likely alternate SIS vendors, with surface-level pros and cons of each.' },
            deliverableLink: { value: '' },
            notes: { value: '' },
            completionStatus: { value: '' },
            notCompletedExplanation: { value: '' },
            statusEndOfWeek1: { value: '' },
            statusEndOfWeek2: { value: '' },
            statusEndOfWeek3: { value: '' },
            statusEndOfWeek4: { value: '' },
            statusEndOfWeek5: { value: '' },
            statusEndOfWeek6: { value: '' },
            statusEndOfWeek7: { value: '' },
            statusEndOfWeek8: { value: '' },
        },
        {
            id: { value: 24 },
            name: { value: 'Attendance vs. GPA Trends Analysis' },
            manager: { value: 'Patrick' },
            description: { value: 'At request of Academics Team, pull data on attendance and GPA for the current and prior semesters and analyze for actionable trends.' },
            category: { value: 'Attendance' },
            categoryLead: { value: 'Patrick' },
            estimatedProjectSize: { value: '8 - Medium-to-Large' },
            mustDo: { value: 'Nice-to-Have' },
            externalDueDate: { value: '' },
            deliverables: { value: 'Spreadsheet of analysis. Possibly Slides presentation as well.' },
            deliverableLink: { value: '' },
            notes: { value: '' },
            completionStatus: { value: '' },
            notCompletedExplanation: { value: '' },
            statusEndOfWeek1: { value: '' },
            statusEndOfWeek2: { value: '' },
            statusEndOfWeek3: { value: '' },
            statusEndOfWeek4: { value: '' },
            statusEndOfWeek5: { value: '' },
            statusEndOfWeek6: { value: '' },
            statusEndOfWeek7: { value: '' },
            statusEndOfWeek8: { value: '' },
        },
    ], // End of queue
};